module.exports = __webpack_public_path__ + "static/media/滷肉便當.bf3aff4b.jpg";